<template>
    <div v-show="can.create.equipment">
        <button-primary @click="open">
            <template slot="icon"><i class="fa fa-plus"></i></template> Ausstattung hinzufügen
        </button-primary>
        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">
                    Ausstattung hinzufügen
                </template>

                <input-text v-model="name" class="mb-4">
                    Name der Ausstattung
                </input-text>

                <div class="flex justify-end">
                    <button-primary v-show="!loading" @click="create">
                        <template slot="icon"><i class="fa fa-save"></i></template> Ausstattung speichern
                    </button-primary>
                </div>

                <loading v-show="loading"></loading>
            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonPrimary from "../UI/ButtonPrimary.vue";
import ButtonSecondary from "../UI/ButtonSecondary.vue";
import Modal from "../Modal.vue";
import Loading from "../UI/Loading.vue";
import InputText from "../UI/InputText.vue";

export default {
    name: "EquipmentCreate",

    components: {InputText, Loading, Modal, ButtonPrimary, ButtonSecondary},

    data: () => ({
        showModal: false,
        loading: false,
        name: '',
    }),

    inject: ['can'],

    methods: {
        open() {
            this.name = '';
            this.showModal = true;
        },
        create() {
            this.loading = true;
            window.axios.post('/admin/equipment', {
                name: this.name,
            }).then(() => {
                this.loading = false;
                this.showModal = false;
                this.$root.$emit('alert', 'Ausstattung erstellt');
                this.$emit('created');
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
    }
}
</script>

<style scoped>

</style>